var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 2.5H9C4 2.5 2 4.5 2 9.5V15.5C2 20.5 4 22.5 9 22.5H15C20 22.5 22 20.5 22 15.5V13.5",
    stroke: "#171717",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0399 3.52025L8.15988 11.4003C7.85988 11.7003 7.55988 12.2903 7.49988 12.7203L7.06988 15.7303C6.90988 16.8203 7.67988 17.5803 8.76988 17.4303L11.7799 17.0003C12.1999 16.9403 12.7899 16.6403 13.0999 16.3403L20.9799 8.46025C22.3399 7.10025 22.9799 5.52025 20.9799 3.52025C18.9799 1.52025 17.3999 2.16025 16.0399 3.52025Z",
    stroke: "#171717",
    strokeWidth: 2.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9102 4.6499C15.5802 7.0399 17.4502 8.9099 19.8502 9.5899",
    stroke: "#171717",
    strokeWidth: 2.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.bcdc6ba83b39cc70c6a9e7335acb4165.svg";
export { ForwardRef as ReactComponent };